/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscaleunderstandingsituationsstrong4Inputs */



/**
* | output |
* | --- |
* | "You understand the emotional context of situations well and take it into account when talking to other people." |
*
* @param {Eisubscaleunderstandingsituationsstrong4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscaleunderstandingsituationsstrong4 = /** @type {((inputs?: Eisubscaleunderstandingsituationsstrong4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscaleunderstandingsituationsstrong4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You understand the emotional context of situations well and take it into account when talking to other people.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Entiendes bien el contexto emocional de las situaciones y lo tienes en cuenta al hablar con otras personas.")
	return /** @type {LocalizedString} */ ("Ты хорошо понимаешь эмоциональный контекст ситуаций и учитываешь его при общении с другими людьми.")
});
export { eisubscaleunderstandingsituationsstrong4 as "eiSubscaleUnderstandingSituationsStrong" }